import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import GuildNavigation from './guild/GuildNavigation.vue';
import GuildChat from './guild/GuildChat.vue';
import MembersList from './guild/GuildMembersList.vue';
import { useGuildStore } from '@/stores/GuildStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheGuild',
  props: {
    guildId: {},
    channelId: {}
  },
  setup(__props: any) {

const guildStore = useGuildStore();

const props = __props;

watch(() => props.guildId, (newGuildId, oldGuildId) => {
  if (newGuildId !== oldGuildId && newGuildId != null) {
    guildStore.getGuildById(newGuildId);
  }
}, { immediate: true });

watch(() => props.channelId, (newChannelId, oldChannelId) => {
  if (newChannelId !== oldChannelId && newChannelId != null) {
    guildStore.setActiveChannel(newChannelId);
  }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GuildNavigation),
    (_ctx.channelId)
      ? (_openBlock(), _createBlock(GuildChat, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(MembersList)
  ], 64))
}
}

})